import { positiveNumberPattern } from "@utils/constants";
import cn from "classnames";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

interface NumberFieldProps {
  defaultValue?: string;
  onChange: (value: number) => void;
  errors: string[];
  label: string;
}

const NumberField: React.FC<NumberFieldProps> = ({
  defaultValue,
  onChange,
  errors,
  label,
}) => {
  const { locale } = useRouter();

  const [value, setValue] = useState<string>("");
  useEffect(() => {
    setValue(defaultValue ?? "");
  }, [defaultValue]);

  const handelChangeValue = (text: string) => {
    setValue(text);
    onChange(Number(text));
  };
  return (
    <div className="md:w-full sm:w-full xs:w-full w-full p-1">
      <div className="form__group w-full h-14 bg-[#F5F5F5] rounded-xl relative">
        <input
          value={value}
          onChange={(e) => {
            const v = e.target.value;
            if (
              new RegExp(positiveNumberPattern, "i").test(v as string) ||
              !v
            ) {
              handelChangeValue(v);
            }
          }}
          type="text"
          className={cn(
            "form__control border-2 border-[transparent] outline-0 bg-transparent h-full w-full rounded-xl pt-3 pb-2 px-4 text-sm font-normal",
            errors.length ? "err-input" : "",
            locale?.includes("ar-") ? "text-right" : ""
          )}
          autoComplete="nope"
        />
        <label
          className={cn(
            "form__label px-4 text-[#999999] text-sm font-normal",
            errors.length ? "err-label" : "",
            value ? "top-label" : "",
            locale?.includes("ar") ? "right-0" : "left-0"
          )}
        >
          {label}
        </label>
      </div>
      {errors.length
        ? errors.map((err) => (
          <div key={`err-${err}`} className="w-full mt-1 pl-2">
            <p className={`text-red-500 text-xs font-normal ${locale?.includes("ar") ? " float-right" : " float-left"}`}>{err}</p>
          </div>
        ))
        : null}
    </div>
  );
};

export default NumberField;
